<template>
    <div class="noPermissios">
      <div class="noPermissios-main">
        <div>
          <img src="../assets/images/icon_permissions.png" alt="">
        </div>
        <div class="one">抱歉，您暂未被分配权限。</div>
        <div class="two">请联系公司管理员为您分配权限后重新登陆本系统。</div>
        <div class="three">
          <!-- <el-button type="primary" @click="intoIndexHome">切换公司</el-button> -->
          <span>当前单位：</span>
           <el-select placeholder="请选择" size="small"  @change="onCompanySelect" v-model="companyName" class="selectCompany">
              <template v-for="(item, index) in enterprises">
                <el-option
                  v-if="!isOwner || (isOwner && item.enterpriseName !== '创建渔场')"
                  :key="item.enterpriseId"
                  :label="item.enterpriseName"
                  :value="item.enterpriseId"
                >
                </el-option>
              </template>
          </el-select>
        </div>
       
      </div>
     
    </div>   
</template>

<script>
import url from "../service/base-url";
import { modules, store } from "../store";
import { mapActions, mapState, mapGetters } from "vuex";
export default {
  name: "noPermissios",
  data() {
    return {
      companyName: "",
      enterprisesList: [],
      isOwner: ''
    };
  },
  computed: {
    ...mapState(modules.account, ["enterprises"])
  },

  methods: {
    ...mapActions(["getCurCompany"]),
    ...mapActions(modules.account, ["getUserCompany"]),
    intoIndexHome() {
      window.location.href = url.ylwUrl;
    },
    //获取切换公司-公司列表
    async getCompanys() {
      await this.getUserCompany();
      this.companyName = this.enterprises.find(
        f => f.selected == true
      ).enterpriseId;
    },
    async onCompanySelect(id) {
      if (id == -2) {
        this.$router.push({
          name: "CreateFishery"
        });
      } else {
        const company = (this.enterprises || []).find(
          f => f.enterpriseId == id
        );
        this.$router.replace({
          name: "switchingCompany",
          query: {
            id: String(id),
            name: company ? company.enterpriseName : ""
          }
        });
      }
    }
  },
  async mounted() {
    await this.getCompanys();

    let hasEnterPrise = await this.getCurCompany();
    this.isOwner = hasEnterPrise.isOwner
  }
};
</script>

<style lang="stylus">
.noPermissios
  background: #fff!important;
  width: 100%;
  height: 100vh;
  position relative
  .noPermissios-main
    text-align center;
    position absolute;
    left:40%;
    top:20%;
    img 
      width: 140px;
      height: 140px;
    .one
      font-size:28px;
      color:#3389ff;
    .two
      font-size:16px;
      margin-top:10px;
      font-family:MicrosoftYaHei;
      color:rgba(51,51,51,1);
    .three
      margin-top:20px;
      .el-button
        width:100px;
        height:40px;
        background:rgba(51,137,255,1);
        border-radius:4px;
</style>
